/* ==========================================================================
   FAQ POLLS FORM
   ========================================================================== */

window.addEventListener("load", function () {
  for (const faqSection of document.querySelectorAll<HTMLElement>(
    ".faq-section"
  )) {
    for (const accordion of faqSection.querySelectorAll<HTMLDetailsElement>(
      ".accordion"
    )) {
      const gform = accordion.querySelector<HTMLDivElement>(".gform_wrapper");

      if (gform) {
        // Hide the "View Poll Results" button
        const pollButtons =
          gform.querySelectorAll<HTMLButtonElement>(".gpoll_button");
        pollButtons.forEach((pollButton) => {
          pollButton.classList.add("hidden");
          pollButton.style.display = "none";
        });

        // If there is only one field (minus the honeypot) hide the submit button
        let hideSubmitButton = true;
        const gfields = gform.querySelectorAll<HTMLDetailsElement>(".gfield");
        const submitButton = gform.querySelector<HTMLButtonElement>(
          "input[type='submit']"
        );

        if (submitButton) {
          // Max fields can be ONE poll, excluding honeypot
          let pollCount = 0;

          for (const gfield of gfields) {
            if (gfield.classList.contains("gfield--type-honeypot")) {
              // Ignore if honeypot field
            } else if (gfield.classList.contains("gfield--type-poll")) {
              pollCount++;
            } else {
              hideSubmitButton = false;
            }
          }

          if (hideSubmitButton && pollCount <= 1) {
            // Hide the gfooter & submit button visibly
            const gfooter =
              gform.querySelector<HTMLDivElement>(".gform_footer");
            if (gfooter) {
              gfooter.style.setProperty("margin-top", "0px", "important");
              gfooter.style.setProperty("visibility", "hidden", "important");
              gfooter.style.setProperty("height", "0px", "important");
              gfooter.style.setProperty("overflow", "hidden", "important");
            }

            submitButton.style.setProperty("visibility", "hidden", "important");
            submitButton.style.setProperty("width", "0px", "important");
            submitButton.style.setProperty("height", "0px", "important");
            submitButton.style.setProperty("overflow", "hidden", "important");

            // Add a submit action on poll click since we're hiding the submit button
            for (const pollButton of gform.querySelectorAll<HTMLDetailsElement>(
              ".gfield-choice-input"
            )) {
              pollButton.addEventListener("click", () => {
                submitButton.click();
                // trigger window resize after poll results for GSAP
                setTimeout(() => {
                  window.dispatchEvent(new Event("resize"));
                }, 500);

                // Reveal the gfooter again to display that loading icon
                if (gfooter) {
                  gfooter.style.removeProperty("margin-top");
                  gfooter.style.removeProperty("visibility");
                  gfooter.style.removeProperty("height");
                  gfooter.style.removeProperty("overflow");
                }
              });
            }
          }
        }
      }
    }
  }
});
